import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Context, LoginData, TelegramSettings, TelegramUser } from './types';
import { miniApp, retrieveLaunchParams } from '@tma.js/sdk';

const AppContext = createContext<Context | undefined>(undefined);

const MOCK_LOGIN_DATA: LoginData = {
  pointsTotal: 1000,
  baseMultiplier: 2,
  daysInactive: 2,
  firstTime: false,
  highestMultiplier: 3,
  pointsEarned: 1233,
};

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [telegramData, setTelegramData] = useState<Context['telegramData']>(null);
  const [loginData, setLoginData] = useState<LoginData | null>(null);
  const [dataIsReady, setDataIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        var user: TelegramUser
        var settings: TelegramSettings

        if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS === 'true') {
          console.warn('Using development mock data');
          user = {
            id: Number(import.meta.env.VITE_MOCK_TG_ID) || 0,
            firstName: '',
            lastName: '',
            username: import.meta.env.VITE_MOCK_TG_USERNAME || '',
          }
          settings = {
            isDarkMode: false,
            apiHost: import.meta.env.VITE_MOCK_API_HOST || 'https://notapp.gewiahr.ru/api',
          }
        
        } else {
          await miniApp.ready();
          const { tgWebAppData } = retrieveLaunchParams();
          const tgUser = tgWebAppData?.user;

          if (!tgUser) {
            // No Telegram user → throw to trigger catch
            throw new Error('Telegram data not available');
          }

          user = {
            id: tgUser.id,
            firstName: tgUser.first_name,
            lastName: tgUser.last_name || '',
            username: tgUser.username || '',
          };

          settings = {
            isDarkMode: miniApp.isDark(),
            apiHost: 'https://notapp.gewiahr.ru/api',
          };        
        }

        setTelegramData({ user, settings });

        const response = await axios.post(`${settings.apiHost}/login`, {
          tgID: user.id,
          tgLogin: user.username,
        });

        if (response.status === 200 || response.status === 201) {
          setLoginData(response.data);
        } else {
          throw new Error('Login failed');
        }

      } catch (error) {
        console.error('Initialization error:', error);

        if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS === 'true') {
          console.warn('Using development mock data');
          //setTelegramData({ user: MOCK_USER, settings: MOCK_SETTINGS });
          setLoginData(MOCK_LOGIN_DATA);
        }
      } finally {
        setDataIsReady(true);
      }
    };

    init();
  }, []);

  // if (!dataIsReady) {
  //   return <div>Loading...</div>;
  // }

  return (
    <AppContext.Provider value={{ telegramData, loginData, dataIsReady }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for consumers
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};